export default __webpack_public_path__ + "static/media/sync-icon.9cc1dc5b.svg";